import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FunctionService {

  constructor() { }

  convertUrl(url: string): [string, number] {
    const newUrl = url.replace(
      /(https:\/\/)youtu.be\/(\S+)\?(?:list=\w+)?(?:.t=(\d+))?/,
      '$1www.youtube.com/watch?v=$2&t=$3'
    );
    const tValueMatch = url.match(/t=(\d+)/);
    const tValue = tValueMatch ? tValueMatch[1] : null;
    const value = Number(tValue);
    return [newUrl, value];
  }

  parserYTID(url: string): string {
    const videoID = url.match(
      /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/
    );
    if (videoID != null) {
      return videoID[1];
    } else {
      return '';
    }
  }
}
